import { DesignSystem, DesignSystemAccessMode, DesignSystemSwitcher, ObjectMeta, } from "@supernova-studio/model";
import { z } from "zod";
export const DTODesignSystemUpdateInput = DesignSystem.partial()
    .omit({
    id: true,
    workspaceId: true,
    createdAt: true,
    updatedAt: true,
    docSlug: true,
    docViewUrl: true,
    accessMode: true,
    iconFileId: true,
    iconFilePath: true,
})
    .extend({
    meta: ObjectMeta.partial().optional(),
    iconFileId: z.string().nullish(),
    /**
     * @deprecated Use the `designSystems.updateSwitcher` endpoint instead
     */
    designSystemSwitcher: DesignSystemSwitcher.optional(),
});
export const DTODesignSystemUpdateAccessModeInput = z.object({
    accessMode: DesignSystemAccessMode,
    retain: z
        .object({
        userIds: z.string().array(),
        inviteIds: z.string().array(),
    })
        .optional(),
});
export const DTODesignSystemUpdateSwitcherInput = z.object({
    designSystemSwitcher: DesignSystemSwitcher,
});
